export const CheckWidgetCardDesignConfig = {
  active_work: {
    textButton: $localize`Detener`,
    label: $localize`En curso`,
    colorButton: `danger`,
    iconButton: `stop_circle`,
    classBgStatus: `bg-emerald-500`,
  },
  desactive_work: {
    textButton: $localize`Iniciar`,
    label: $localize`Detenido`,
    colorButton: `blue`,
    iconButton: `play_circle_filled`,
    classBgStatus: `qaroni-bg-danger-light`,
  },
  active_break: {
    textButton: $localize`Reanudar trabajo`,
    label: $localize`En pausa`,
    colorButton: `secondary`,
    iconButton: `play_circle_filled`,
    classBgStatus: `qaroni-bg-primary50`,
  },
  desactive_break: {
    textButton: $localize`Iniciar Pausa`,
    label: $localize`En curso`,
    colorButton: `accent`,
    iconButton: `play_circle_filled`,
    classBgStatus: `qaroni-bg-danger-light`,
  },
};
